{
	"meta": {
		"title": "About — UpSquad",
		"description": "Every community deserves a world-class home. UpSquad's vision, mission, and the story behind the platform."
	},
	"hero": {
		"eyebrow": "About UpSquad",
		"title": "We believe every community deserves a",
		"title_accent": "world-class home."
	},
	"vision": {
		"eyebrow": "Our vision",
		"title": "Spaces where people grow.",
		"body": "To build positive spaces where every person — regardless of where they start — can learn, grow, find their people, and unlock a future they never thought possible."
	},
	"mission": {
		"eyebrow": "Our mission",
		"title": "AI-powered tools for the people who run communities.",
		"body": "To give organizations around the world the AI-powered tools and community infrastructure they need to truly support every member — so that learning and growth become the rule, not the exception."
	},
	"story": {
		"paragraph_1": "Most organizations doing meaningful work — training entrepreneurs, supporting adult learners, building mentorship programs — are piecing together six or seven different tools just to keep their community connected. They spend more time managing software than serving people.",
		"paragraph_2": "We built UpSquad because we believe the best communities are branded, structured, and powered by AI that actually understands your members. Not a generic social platform. Not a clunky LMS. A space that feels like yours — and works like a team of people behind the scenes.",
		"paragraph_3": "From Nashville to New York to the entire United States, communities on UpSquad are helping adults finish high school, medical students thrive, entrepreneurs launch businesses, and college students become coaches. That's what happens when you give community leaders the right tools."
	},
	"beliefs": {
		"title": "What we",
		"title_accent": "believe.",
		"subtitle": "Four principles that shape every decision we make.",
		"items": {
			"1": {
				"title": "Community first",
				"body": "Every feature we build starts with one question: does this help the people in the community?"
			},
			"2": {
				"title": "AI with purpose",
				"body": "AI should surface insight and connection — not replace the human relationships that make communities powerful."
			},
			"3": {
				"title": "Simplicity at scale",
				"body": "World-class community infrastructure shouldn't require a team of developers. We build it so you don't have to."
			},
			"4": {
				"title": "Impact over everything",
				"body": "We measure success by the outcomes our customers create — diplomas earned, jobs landed, connections made."
			}
		}
	}
}
